// extracted by mini-css-extract-plugin
export default {"wrapper":"editorial-document__wrapper___12U3m","columnsContainer":"editorial-document__columnsContainer___15Q1h"};